import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Flexmargin from '../../common/Flexmargin';

import tr from '../../localization/translate';
import config from '../../igglo_config';

import logo from '../../assets/images/igglo-logo.svg';
import whiteLogo from '../../assets/images/igglo-logo-white.svg';
import s from './Header.scss';

function Header({ hideLink, invertedColors }) {
  return (
    <header className={classNames(s.head, { [s.inverted_colors]: invertedColors })}>
      <Flexmargin />

      <div styleName="center">
        <a
          className="nakedButton no_decor"
          href={config.marketingSiteUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img role="presentation" styleName="logo" src={invertedColors ? whiteLogo : logo} />
        </a>

        { !hideLink ? (
          <a // eslint-disable-line jsx-a11y/control-has-associated-label
            className={classNames('text', s.marketing_link, {
              watermelon: !invertedColors,
              white: invertedColors
            })}
            href={config.marketingSiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: tr('simple_pages.share_profile.header_link')
            }}
          />
        ) : null}

      </div>

      <Flexmargin />
    </header>
  );
}

Header.propTypes = {
  hideLink: PropTypes.bool,
  invertedColors: PropTypes.bool
};

Header.defaultProps = {
  hideLink: false,
  invertedColors: false
};

export default Header;
